import React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import Zmage from 'react-zmage';
import {
  Row, Col,
} from 'antd';
import Instruction from '../../util/appApply/Instruction';

const store = [];
@inject(...store)
@observer
class App extends React.Component {

  render() {
    const server = window.server;
    const { prefixCls } = this.props;
    let { modeListStore: { appDetail } } = this.props;
    appDetail = toJS(appDetail);
    const { app } = appDetail;
    return (
      <div className={prefixCls}>
        <Row className={`${prefixCls}-header ${prefixCls}-detailRow`}>
          <Col span={8}>
            <div className={`${prefixCls}-header-row app-text-elli`}>
              <span className="app-detail-label">适用行业：</span>
              <span title={app && app.s_tradename}>{app && app.s_tradename}</span>
            </div>
            <div className={`${prefixCls}-header-row app-text-elli`}>
              <span className="app-detail-label">浏览器兼容：</span>
              <span title={app && app.s_inter}>{app && app.s_inter}</span>
            </div>
          </Col>
          <Col span={8}>
            <div className={`${prefixCls}-header-row app-text-elli`}>
              <span className="app-detail-label">EC兼容：</span>
              <span title={app && app.s_ec}>{app && app.s_ec}</span>
            </div>
            <div className={`${prefixCls}-header-row app-text-elli`}>
              <span className="app-detail-label">数据库支持：</span>
              <span title={app && app.s_tradename}>{app && app.s_database}</span>
            </div>
          </Col>
          <Col span={8}>
            <div className={`${prefixCls}-header-row app-text-elli`}>
              <span className="app-detail-label">所属模块：</span>
              <span title={app && app.s_typename}>{app && app.s_typename}</span>
            </div>
            <div className={`${prefixCls}-header-row app-text-elli`}>
              <span className="app-detail-label">终端：</span>
              <span title={app && app.s_apptype}>{app && app.s_apptype}</span>
            </div>
          </Col>
        </Row>
        <div className={`${prefixCls}-detailRow`}>
          <div className={`${prefixCls}-header-row app-text-elli`}>
            <span className="app-detail-label">使用文档：</span>
            <Instruction />
            {
              app && app.usefile && app.usefile.map(file => (<a key={file.uid} alt="" title={file.name} href={`${server}${file.url}`} target="_blank">、{file.name}</a>))
            }
          </div>
        </div>
        <div className={`${prefixCls}-detailRow`}>
          {
            app && (<span dangerouslySetInnerHTML={{__html: app.s_desc }} />)
          }
        </div>
        <div className={`${prefixCls}-detailRow`}>
          {
            app && app.imgfile.map((img, index) => (
              <Zmage src={`${server}${img.url}`} key={`imgFile${index}`} className={`${prefixCls}-zmage`} />
            ))
          }
        </div>
      </div>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/mode/appDetail/BasicInfo.js